import { Field, Label, Select, Switch } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { Checkbox } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/16/solid';
import clsx from 'clsx';
import { VolumeUp, VolumeMute } from 'react-bootstrap-icons';

const DmFilterBar = ({
  sortOrder,
  setSortOrder,
  statusFilter,
  setStatusFilter,
  playAudio,
  setPlayAudio,
}: {
  sortOrder: string;
  setSortOrder: any;
  statusFilter: any;
  setStatusFilter: any;
  playAudio: boolean;
  setPlayAudio: any;
}) => {
  return (
    // <CommentStatus />
    <div className="flex flex-row w-full mx-4">
      <Field>
        <Label className="text-xs font-medium text-white">Comment status</Label>
        <div className="relative">
          <Select
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              console.log(e.target.value);
            }}
            className={clsx(
              'cursor-pointer mt-1 block w-full appearance-none rounded-lg border-none bg-white/5 py-1.5 px-3 text-sm/6 text-white',
              'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25',
              // Make the text of each option black on Windows
              '*:text-black'
            )}
          >
            <option value="all">All</option>
            <option value="0">Unread</option>
            <option value="1">Viewed</option>
            <option value="2">Resolved</option>
          </Select>
          <ChevronDownIcon
            className="group pointer-events-none absolute top-2.5 right-2.5 size-4 fill-white/60"
            aria-hidden="true"
          />
        </div>
      </Field>
      <div className="ml-auto flex">
        <Field>
          <Label className="text-xs font-medium text-white">
            Audio Notifications
          </Label>
          <Switch
            checked={playAudio}
            onChange={setPlayAudio}
            className="ml-auto mt-1 group relative flex h-7 w-14 cursor-pointer rounded-full bg-white/10 p-1 transition-colors duration-200 ease-in-out focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[checked]:bg-violet"
          >
            <span
              aria-hidden="true"
              className="pointer-events-none inline-block size-5 translate-x-0 rounded-full bg-white ring-0 shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-7"
            />
          </Switch>
        </Field>
      </div>
    </div>
  );
};

export default DmFilterBar;
